var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkoSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 639.954,
    height: 639.693,
    viewBox: "0 0 639.954 639.693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.383 236.297C328.705 144.015 478.39 144.015 570.712 236.297C663.034 328.579 663.034 478.199 570.712 570.481C478.39 662.763 328.705 662.763 236.383 570.481C144.059 478.199 144.059 328.579 236.383 236.297Z",
    fill: "#6DD49E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.937 17.9865C117.255 29.8622 91.1938 47.2682 69.242 69.2119C47.2887 91.1542 29.8751 117.204 17.9943 145.874C6.1149 174.543 0 205.271 0 236.304C0 267.335 6.1149 298.063 17.9943 326.733C29.8751 355.402 47.2887 381.452 69.242 403.396C91.1938 425.338 117.255 442.744 145.937 454.62C174.619 466.496 205.36 472.608 236.407 472.608C266.087 472.608 295.489 467.021 323.08 456.153C325.617 455.153 328.072 453.982 330.46 452.665C336.573 449.295 349.719 441.895 363.735 433.043C386.949 418.382 387.82 387.689 368.427 368.267L403.571 403.396C425.523 381.452 442.936 355.402 454.817 326.733C466.698 298.063 472.813 267.335 472.813 236.304C472.813 205.271 466.698 174.543 454.817 145.874C442.936 117.204 425.523 91.1542 403.571 69.2119C381.618 47.2682 355.557 29.8622 326.875 17.9865C298.193 6.11224 267.451 0 236.407 0C205.36 0 174.619 6.11224 145.937 17.9865Z",
    fill: "#CDF1DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M299.456 299.33C264.411 264.3 268.909 208.224 312.556 184.754C314.162 183.891 313.54 184.324 315.232 183.646C343.187 172.45 373.033 166.691 403.166 166.691C434.211 166.691 464.953 172.803 493.635 184.679C522.317 196.554 548.378 213.96 570.331 235.903C592.283 257.846 609.696 283.896 621.577 312.566C633.458 341.235 639.573 371.963 639.573 402.996C639.573 434.027 633.458 464.755 621.577 493.425C609.696 522.094 592.283 548.144 570.331 570.088L299.456 299.33Z",
    fill: "#6DD49E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M184.15 496.078C189.458 508.457 203.74 530.018 203.74 530.018C203.74 530.018 228.03 530.387 253.365 524.796C287.853 517.185 322.795 503.91 351.525 466.055C380.257 428.198 380.869 410.015 380.869 410.015C380.869 410.015 360.057 450.491 291.271 465.091C239.418 476.098 171.091 463.443 171.091 463.443C171.091 463.443 178.493 482.883 184.15 496.078Z",
    fill: "#3FC67E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkoSymbol);
export default __webpack_public_path__ + "static/media/LinkoSymbol.4030e8a1bbd60b6d1fc7250a1a0c764c.svg";
export { ForwardRef as ReactComponent };